import {initAbility,logout} from '@/api/user'
import {removeToken,getToken} from "@/utils/auth";
import {getMyCvList} from "@/api/cv"

const state = {
  userType:'public',
  userInfo:null,
  enterpriseInfo:null,
  enterpriseFilled:true,
  ability:null,
  isHR:false
}

const mutations = {
  CHANGE_USER_TYPE: (state,userType) => {
    state.userType = userType
  },
  CHANGE_USER_INFO: (state,userInfo) => {
    state.userInfo = userInfo
  },
  CHANGE_ENTERPRISE_INFO: (state,enterpriseInfo) => {
    state.enterpriseInfo = enterpriseInfo
  },
  CHANGE_ABILITY :(state,ability) => {
    state.ability = ability
  },
  LOGOUT_USER_ALL: (state) => {
    state.userType = 'public'
    state.userInfo = null
    state.enterpriseInfo = null
    state.ability =null
  },
  CHANGE_FILL_INFO:(state,filled) => {
    console.log(filled)
    state.enterpriseFilled = filled
  },
  CHANGE_USER_HR:(state,isHR) => {
    state.isHR = isHR
  },
  UPDATE_CHECK_STATE:(state,checkState)=>{
    state.enterpriseInfo.checkState = checkState
  },
  UPDATE_USER_CV:(state,cvInfo)=>{
    // cvState:0,未创建简历；1.已创建简历，但不完善；2.已创建简历并完善。
    if(cvInfo!=null){
      if(cvInfo.basicInfo!=null && cvInfo.workRequired!=null && cvInfo.workExperience!=null && cvInfo.workExperience.length>0 && cvInfo.educationExpirence!=null && cvInfo.educationExpirence.length>0){
        state.userInfo.cvState = 2
      }else{
        state.userInfo.cvState = 1
      }
      state.userInfo.cvId = cvInfo.basicInfo.id
    }else{
      state.userInfo.cvState = 0
      state.userInfo.cvId = ''
    }
  }
}

const actions = {
  loadAbility({ commit }) {
      return new Promise(function(resolve, reject){
        initAbility().then(response => {
          console.log("权限参数:" + response)
          let userType = response.sessionParam.identity
          if (userType == 'personal') {
            let userInfo = JSON.parse(response.sessionParam.userInfomation)
            commit('CHANGE_USER_TYPE',userType)
            commit('CHANGE_USER_INFO',userInfo)
            if (response.sessionParam.extRole!=null) {
              let extRole = JSON.parse(response.sessionParam.extRole)
              for (let i = 0; i < extRole.length; i++) {
                if (extRole[i].extType == 0 && extRole[i].state == 1) {
                  commit('CHANGE_USER_HR', true)
                }
              }
            }
            // 获取个人简历
            getMyCvList().then(resp =>{
              if(resp.cvList!=null && resp.cvList.length>0){
                const cvInfo = resp.cvList[0]
                console.log("======");
                console.log(cvInfo);
                commit('UPDATE_USER_CV',cvInfo)
              }else{
                commit('UPDATE_USER_CV',null)
              }
              resolve("权限初始化完成");
            }).catch(error => {
              console.log(error)
              commit('UPDATE_USER_CV',null)
              resolve("权限初始化完成");
            })
          }
          if (userType == 'enterprise'){
            let userInfo = JSON.parse(response.sessionParam.userInfomation)
            let enterpriseInfo = JSON.parse(response.sessionParam.enterpriseInfomation)
            let ability = JSON.parse(response.sessionParam.ability)
            commit('CHANGE_USER_TYPE',userType)
            commit('CHANGE_USER_INFO',userInfo)
            commit('CHANGE_ENTERPRISE_INFO',enterpriseInfo)
            commit('CHANGE_ABILITY',ability)
            resolve("权限初始化完成")
          }
          
        }).catch(error => {
          console.log(error)
          reject("权限初始化异常")
        })
      })
  },
  requestToken({commit}){

  },
  userLogout({commit}){
    logout().then(response => {
      commit('LOGOUT_USER_ALL')
      removeToken()
      window.location.href = 'http://www.hiturnjob.com'
    }).catch(error => {

    })
  },
  checkInfoFill({commit,state}){
    if (state.userType == 'personal'){
      if (state.userInfo.wxUnionId==null){
        console.log("用户未绑定微信,调用微信绑定提示")
        let token = getToken()
        let userId = state.userInfo.id
        let type = state.userType
        $("#personModal").modal()
        var obj = new WxLogin({
          self_redirect:true,
          id:"wx-code-new",
          appid: "wx29326039d5664095",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("https://app.hiturnjob.com/wxUnion.html?&type=" + type +"&token=" + token + "&method=bind"),
          state: "checked",
          style: "white",
          href: "https://www.hiturnjob.com/qc1.css"
        });
      }
    }
    if (state.userType == 'enterprise'){
      if (!state.enterpriseInfo.infomationFill){
        console.log("用户未完成基础信息填写,调用信息填写提示")
        $("#enterpriseModal").modal()
      }else{
        if (state.userInfo.wxUnionId==null){
          console.log("用户未绑定微信,调用微信绑定提示")
        }
      }
    }
  },
  updateEnterpriseFilled({commit}){
    commit('CHANGE_FILL_INFO',true)

  },
  updateCheckState({commit},checkState){
    commit('UPDATE_CHECK_STATE',checkState)
  },
  userCvInfo({commit},data){
    commit('UPDATE_USER_CV',data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js